import { Button } from 'design-system';
import { ArrowRight } from 'lucide-react';

import { useNoMessagesScreen } from './useNoMessagesScreen';

const NoMessagesScreen = ({
  prompts = [
    "Show me today's Morning Intel briefing",
    "What's new in my Crude Diffs — NWE dashboard?"
  ]
}: {
  prompts?: string[];
}) => {
  const { sendMessage } = useNoMessagesScreen();

  return (
    <div className='size-full overflow-auto bg-[#0a0a0f]'>
      <div className='flex w-full flex-col gap-3 px-4 py-4'>
        <p className='max-w-[95%] rounded-[3px] border border-[rgba(140,124,240,0.32)] border-l-[3px] border-l-[#8c7cf0] bg-[rgba(140,124,240,0.12)] px-3 py-3 text-[13px] leading-[1.55] font-normal text-[#f3f2ed]'>
          Morning. Yesterday&apos;s batch flagged{' '}
          <strong className='font-bold'>3 high-importance signals</strong> — Dubai structure flipped
          to contango, Midland–Cushing is softening, and majors are selling Dated together. Where do
          you want to start?
        </p>
        <div className='grid grid-cols-1 gap-2'>
          {prompts.map((prompt, index) => (
            <Button
              key={prompt}
              aria-label={index === 0 ? 'Check Morning Intel' : 'Recent activity detected'}
              className='group h-auto justify-between gap-2.5 rounded-[3px] border-[#66677a] bg-[#17181f] px-[13px] py-3 text-left whitespace-normal text-[#f3f2ed] hover:border-[#8c7cf0] hover:bg-[#20222c]'
              size='lg'
              variant='outline'
              onClick={() => {
                sendMessage(prompt);
              }}
            >
              <span className='min-w-0'>
                <span className='mb-[3px] block text-[13px] leading-[1.35] font-extrabold'>
                  {index === 0 ? 'Check Morning Intel' : 'Recent activity detected'}
                </span>
                <span className='block text-xs leading-[1.45] font-normal break-words text-[#9fa0ad]'>
                  {index === 0
                    ? "View today's market briefing"
                    : 'Your Crude Diffs — NWE dashboard has new activity today — worth a look.'}
                </span>
              </span>
              <ArrowRight
                aria-hidden='true'
                className='size-[15px] shrink-0 text-[#66677a] transition-transform group-hover:translate-x-0.5'
                data-icon='inline-end'
              />
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NoMessagesScreen;
